import { clx } from '@medusajs/ui';
import React from 'react';

import Button from '@modules/common/components/button';
import Container from '@modules/common/components/container';
import Spinner from '@modules/common/icons/spinner';

interface ActionBarAlertProps {
  show: boolean;
  message: string;
  actionBtnText: string;
  actionBtn: () => void;
}

interface ActionButton {
  text: string;
  disabled?: boolean;
  loading?: boolean;
  'data-testid'?: string;
  action: () => void;
}

interface ActionBarProps {
  className?: string;
  alert?: ActionBarAlertProps | null;
  actionInfo?: React.ReactNode;
  prevBtn?: ActionButton;
  nextBtn?: ActionButton;
}

const ActionBarAlert = (alert: ActionBarAlertProps) => {
  return (
    <div className="bg-orange-30_op10 text-orange-30 py-3 text-center">
      {alert.message}
      {alert.actionBtnText && (
        <Button
          onClick={alert.actionBtn}
          variant="contrast"
          className="bg-orange-20 text-white-10 ml-4"
        >
          {alert.actionBtnText}
        </Button>
      )}
    </div>
  );
};

const ActionBar = ({
  className,
  alert,
  actionInfo,
  prevBtn,
  nextBtn,
}: ActionBarProps) => {
  return (
    <div className={clx(className, 'bg-white-20 border-t border-gray-100')}>
      {alert?.show && <ActionBarAlert {...alert} />}
      <Container className="relative z-10 flex flex-wrap items-center justify-end gap-6 pt-6">
        {actionInfo}
        {prevBtn && (
          <Button onClick={prevBtn.action} variant="outlined" className="px-6 py-3" data-testid={prevBtn['data-testid']}>
            {prevBtn.text}
          </Button>
        )}
        {nextBtn && (
          <Button
            onClick={nextBtn.action}
            variant="primary"
            className="px-6 py-3"
            disabled={nextBtn.disabled || false}
            data-testid={nextBtn['data-testid']}
          >
            {nextBtn.loading ? (
              <Spinner className="h-6 animate-spin" />
            ) : (
              nextBtn.text
            )}
          </Button>
        )}
      </Container>
    </div>
  );
};

export default ActionBar;
